import queryString from 'query-string';
import * as actionTypes from './types';
import * as api from '../../api/base';
import { endpoints } from '../../api/endpoints';
import { GENERIC_ERROR_MESSAGE } from '../../helpers/apiHelper';

export const getWholeFarmDetailedTable = (params) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.wholeFarm.tables.concat('?', queryString.stringify(params)));
    if (response && response.status === 200) {
      return dispatch(getWholeFarmDetailedTableSuccess(response?.data));
    } else
      return dispatch(getWholeFarmDetailedTableFail(response?.data?.error?.message || GENERIC_ERROR_MESSAGE));

  } catch (error) {
    return dispatch(getWholeFarmDetailedTableFail(error?.data?.error?.message || GENERIC_ERROR_MESSAGE));
  }
}

/**
 * AGC-2598 Soil Carbon data needs adjusting here as a stopgap Remove after full fix 
 * TODO remove once we properly fix the backend api
 * 
 * @param {*} results 
 * @param {*} field 
 */
const calculateWholeFarmTotal = (results, field) => {
  if (results && field) {
    const WHOLE_FARM = "Whole farm"
    let wholeFarmIdx = results.findIndex((e) => e.itemTitle === WHOLE_FARM);
    if (wholeFarmIdx >= 0) {
      let esList = results.filter((e) => e.itemTitle !== WHOLE_FARM);

      let wholeCFarmTotal = esList.reduce((acc, c) => acc + (c[field] || 0), 0);
      results[wholeFarmIdx][field] = wholeCFarmTotal
    }
  }
}

/**
 * Split soil carbon results into emissions and sequestrations
 * AGC-2598 Soil Carbon data needs adjusting here as a stopgap Remove after full fix
 * @param {*} csResults 
 */
const adjustCarbonSequestration = (csResults) => {
  if (csResults) {
    // Split soil carbon results into emissions and sequestrations
    csResults.forEach((e) => {
      if (e.soilCarbon && !e.scEmissions && !e.scSequestrations) {
        e.scEmissions = e.soilCarbon > 0 ? e.soilCarbon : null;
        e.scSequestrations = e.soilCarbon < 0 ? e.soilCarbon : null;
        delete (e.soilCarbon)
      }
    })
    calculateWholeFarmTotal(csResults, "scEmissions")
    calculateWholeFarmTotal(csResults, "scSequestrations")
  }
}

const getWholeFarmDetailedTableSuccess = (response) => {
  // AGC-2598 Soil Carbon data needs adjusting here as a stopgap Remove after full fix
  // Adjust Carbon Stock emissions in Whole Farm total for the Emission Summary Table
  calculateWholeFarmTotal(response.emissionSummaryResults,"carbonStockChanges")
  adjustCarbonSequestration(response?.carbonSequestrationResults?.results);
  return {
    type: actionTypes.GET_WHOLE_FARM_DETAILED_TABLE_DATA_SUCCESS,
    payload: response
  };
};

const getWholeFarmDetailedTableFail = () => {
  return {
    type: actionTypes.GET_WHOLE_FARM_DETAILED_TABLE_DATA_FAIL,
  };
};

export const getWholeFarmChart = (params) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.wholeFarm.charts.concat('?', queryString.stringify(params)));
    if (response && response.status === 200) {
      return dispatch(getWholeFarmChartSuccess(response?.data));
    } else
      return dispatch(getWholeFarmChartFail(response?.data?.error?.message || GENERIC_ERROR_MESSAGE));
  } catch (error) {
    return dispatch(getWholeFarmChartFail(error?.data?.error?.message || GENERIC_ERROR_MESSAGE));
  }
}

const getWholeFarmChartSuccess = (response) => {
  return {
    type: actionTypes.GET_WHOLE_FARM_CHART_DATA_SUCCESS,
    payload: response
  };
};

const getWholeFarmChartFail = (response) => {
  return {
    type: actionTypes.GET_WHOLE_FARM_CHART_DATA_FAIL,
    payload: response
  };
};

export const getWholeFarmReport = (params) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.wholeFarm.report.concat('?', queryString.stringify(params)));
    if (response && response.status === 200) {
      return dispatch(getWholeFarmReportSuccess(response?.data));
    } else
      return dispatch(getWholeFarmReportFail(response?.data?.error?.message || GENERIC_ERROR_MESSAGE));
  } catch (error) {
    return dispatch(getWholeFarmReportFail(error?.data?.error?.message || GENERIC_ERROR_MESSAGE));
  }
}

const getWholeFarmReportSuccess = (response) => {
  calculateWholeFarmTotal( response.wholeFarmReportResult?.wholeFarmDetailedResult?.emissionSummaryResults,
                           "carbonStockChanges")  
  adjustCarbonSequestration(response.wholeFarmReportResult?.wholeFarmDetailedResult?.carbonSequestrationResults?.results)

  return {
    type: actionTypes.GET_WHOLE_FARM_REPORT_DATA_SUCCESS,
    payload: response
  };
};

const getWholeFarmReportFail = (response) => {
  return {
    type: actionTypes.GET_WHOLE_FARM_REPORT_DATA_FAIL,
    payload: response
  };
};

export const getFarmerFriendlyReport = (params) => async (dispatch) => {
  try {
    const response = await api.get(endpoints.wholeFarm.farmerFriendlyReport.concat('?', queryString.stringify(params)));
    if (response && response.status === 200) {
      return dispatch(getFarmerFriendlyReportSuccess(response?.data));
    } else
      return dispatch(getFarmerFriendlyReportFail(response?.data?.error?.message || GENERIC_ERROR_MESSAGE));
  } catch (error) {
    return dispatch(getFarmerFriendlyReportFail(error?.data?.error?.message || GENERIC_ERROR_MESSAGE));
  }
}

const getFarmerFriendlyReportSuccess = (response) => {
  return {
    type: actionTypes.GET_WHOLE_FARM_REPORT_DATA_SUCCESS,
    payload: response
  };
};

const getFarmerFriendlyReportFail = (response) => {
  return {
    type: actionTypes.GET_WHOLE_FARM_REPORT_DATA_FAIL,
    payload: response
  };
};



